// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__1iZa8"};